import { TAxiosError } from '@mgm/common/types';
import { useRequest } from '@mgm/common/lib';
import { CONTROLLERS } from '../utils/enums';

import { TAddMembersReq, TUpdateMemberReq } from '../types/requests';
import { BASE_URL } from '../../config';
import { getIdToken } from '../utils/helpers';

export function TeamController() {
  const {
    axiosRequest,
    initRequestOptions,
  } = useRequest(BASE_URL);

  const controllerName = CONTROLLERS.TEAM;

  const getTeam = <T>(data: { email: string, shopName: string }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/get_team`, options);
  };

  const addMembers = <T>(data: TAddMembersReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/add_members`, options);
  };

  const updateMember = <T>(data: TUpdateMemberReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/update_member`, options);
  };

  const deleteMember = <T>(data: { email: string, shopName: string }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/delete_member`, options);
  };

  const reInvite = <T>(data: {
    shopName: string,
    email: string,
    invitorName: string
  }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/re_invite`, options);
  };

  const setLocale = <T>(data: {
    shopName: string,
    email: string,
    locale: string
  }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/set_locale`, options);
  };

  const setDateFormat = <T>(data: {
    shopName: string,
    email: string,
    dateFormat: string
  }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/set_date_format`, options);
  };

  return {
    deleteMember,
    getTeam,
    updateMember,
    addMembers,
    reInvite,
    setLocale,
    setDateFormat,
  };
}
